import { components } from "@certn/legacy-api/generated-schemas/people";

export function getDocumentsPoints(
  documents: components["schemas"]["AustralianNpcIdentificationDocumentsCheckField"]["value"]
) {
  return documents.reduce(
    (points, document) => points + (document.points ?? 0),
    0
  );
}

export function isPrimaryDocumentUploaded(
  documents: components["schemas"]["AustralianNpcIdentificationDocumentsCheckField"]["value"]
) {
  return documents.some(
    ({ document_subtype }) => document_subtype === "primary"
  );
}
